var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeclined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 269,
    viewBox: "0 0 299 269",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.514 237.256L37.0261 213.956L38.3271 207.215L163.815 230.514L162.514 237.256Z",
    fill: "#F44747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M296.989 76.9955L197.758 97.2202L196.457 90.4786L295.688 70.254L296.989 76.9955Z",
    fill: "#F44747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237.498 43.88L154.589 56.2987L153.643 49.5571L236.552 37.1385L237.498 43.88Z",
    fill: "#F44747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.898 205.558L118.989 217.859L117.924 211.117L200.834 198.817L201.898 205.558Z",
    fill: "#F44747"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M253.228 26.0206L169.491 26.9667L169.373 20.2252L253.228 19.1607V26.0206Z",
    fill: "#F44747"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M298.172 16.7947L214.908 6.74155L215.736 0L299 10.0532L298.172 16.7947Z",
    fill: "#F44747"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271.562 109.166H170.32V116.025H271.562V109.166Z",
    fill: "#F44747"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.595 140.744L128.215 147.959L127.742 141.099L255.24 133.884L255.595 140.744Z",
    fill: "#F44747"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.959 142.755C272.421 142.755 275.228 139.949 275.228 136.487C275.228 133.025 272.421 130.218 268.959 130.218C265.497 130.218 262.691 133.025 262.691 136.487C262.691 139.949 265.497 142.755 268.959 142.755Z",
    fill: "#F44747"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M282.134 194.615L219.115 155.812L190.28 202.643L253.298 241.446L282.134 194.615Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M236.195 216.651L207.323 198.962L235.89 185.238L236.195 216.651Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M242.295 220.413L222.675 208.417L242.092 199.064L242.295 220.413Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M256.833 188.085L269.54 195.913L256.934 201.911L256.833 188.085Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.548 263.823C204.477 242.982 212.509 222.244 220.438 201.403C222.268 196.625 225.318 180.868 220.743 179.241C216.982 177.919 207.426 190.932 205.596 195.71C197.666 216.551 189.635 237.289 181.705 258.13C178.046 267.686 192.888 273.379 196.548 263.823Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.949 233.935L202.953 265.246L191.16 260.773",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203.867 251.827L183.535 243.999",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M223.996 201.301L203.562 193.473",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M222.471 176.191L217.795 188.594",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M231.025 170.056L231.94 173.208",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M161.997 236.745L158.845 240.812",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M154.373 134.374L157.118 136.611",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M235.599 81.6116L232.346 85.2714",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M236.006 93.4035L239.158 94.2168",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8905 219.666L70.9092 220.988",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3885 172.699L56.0669 176.359",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5706 186.729L22.722 187.644",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3152 97.877C84.0969 97.9862 83.7693 98.0954 83.5509 98.2045C77.9826 100.716 72.0867 103.882 68.702 109.123C68.0469 110.105 67.6102 111.197 67.1735 112.289C62.3694 110.106 57.6745 107.376 54.1807 103.991C54.2898 103.773 54.2899 103.664 54.399 103.445C58.6572 95.3658 65.7541 89.9066 73.6153 85.8668C75.1438 85.1026 76.6724 84.3383 78.201 83.6832C78.7469 83.4648 79.2928 83.2464 79.8387 83.1373C82.5683 82.5913 84.8611 83.574 86.4989 85.3209C89.7744 89.0331 89.9927 95.475 84.3152 97.877Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M142.401 65.2313C140.435 77.0231 131.482 85.6486 120.564 89.6884C108.772 94.0557 95.8885 93.2914 84.2059 97.9863C83.9876 98.0955 83.7692 98.0955 83.5508 98.2047C76.4539 100.388 71.5407 92.1996 74.4886 86.9588C75.2529 85.6486 76.4539 84.5568 78.2009 83.9017C78.7468 83.6833 79.4019 83.4649 79.9478 83.2466C82.459 82.3731 84.9702 81.718 87.4814 81.0629C94.6875 79.4252 102.003 78.7701 109.209 77.1323C116.633 75.4946 125.805 71.564 127.224 63.0477C127.333 62.6109 127.442 62.1742 127.552 61.8467C132.574 62.3926 137.487 62.7201 142.51 63.0477C142.51 63.812 142.51 64.5762 142.401 65.2313Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M127.224 63.1564C128.097 56.6055 127.224 52.1289 128.425 50.8187C129.626 49.5085 129.516 54.4218 131.373 55.0769C133.229 55.732 132.137 47.5432 134.539 46.8881C136.941 46.1239 135.958 53.5483 135.958 53.5483C135.958 53.5483 136.286 46.8881 138.142 47.1065C139.998 47.3249 139.015 53.9851 139.015 53.9851C139.015 53.9851 140.107 47.4341 141.09 47.7616C142.073 48.0892 143.929 50.9279 142.4 65.2309",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M131.373 55.0777C134.321 56.8247 135.195 59.1175 135.195 59.1175L131.373 55.0777Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M131.373 55.0777C134.321 56.8247 135.195 59.1175 135.195 59.1175",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M207.584 112.617C207.584 112.617 219.376 119.168 221.668 121.024L236.299 94.0558C236.299 94.0558 227.455 90.6711 223.852 97.0038L212.715 92.5272L207.584 112.617Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M223.96 97.0032L222.541 101.261",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M221.668 95.9108L219.812 100.06",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M127.334 227.26C127.334 227.26 122.639 237.087 121.11 239.707L149.716 250.844C149.716 250.844 151.9 241.672 145.24 238.943L148.188 227.369L127.334 227.26Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M123.949 227.041C132.684 186.971 109.755 155.308 83.0055 141.878C74.7076 137.729 76.8913 130.742 82.132 125.828C82.4596 123.535 83.5514 121.243 85.08 119.277C116.525 78.4428 176.248 70.6908 218.72 93.0733L206.928 115.237C174.501 98.4233 131.92 99.6243 105.388 127.466C136.614 146.355 162.6 185.442 149.498 231.081C141.637 229.989 131.592 227.587 123.949 227.041Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M145.24 238.833L140.873 237.96",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M146.113 236.431L141.746 235.23",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M124.604 222.782L150.043 225.294",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M213.37 90.9986L202.343 112.617",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3523 142.143L24.7595 135.293L19.5657 165.31L59.1585 172.16L64.3523 142.143Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6152 141.55L26.6672 158.692",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8381 142.643L32.781 159.785",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8338 124.648L45.47 158.029L70.7779 174.984L93.1418 141.603L67.8338 124.648Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1978 156.181L67.6099 165.898",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6921 150.94L71.1043 160.658",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9394 183.889L0.999756 211.168L21.6947 237.674L56.6343 210.395L35.9394 183.889Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3743 200.728L36.166 215.905",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6045 205.969L29.5055 221.145",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8328 196.47L41.6245 211.646",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M117.069 118.293L80.0562 132.378C78.6368 132.924 77.1082 132.16 76.5623 130.849L66.7358 104.973C66.1899 103.554 66.9542 102.025 68.2644 101.479L105.278 87.3946C106.697 86.8487 108.225 87.6129 108.771 88.9231L118.598 114.8C119.253 116.11 118.489 117.747 117.069 118.293Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3516 105.968L89.1687 107.563L90.8415 111.95L95.0243 110.355L93.3516 105.968Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5747 113.817C54.7258 133.798 63.6788 126.373 71.7584 129.212C79.8379 132.051 67.7186 154.324 63.3513 173.431C58.8748 193.412 90.7562 168.3 96.6521 178.89C102.766 189.809 54.0707 243.418 19.1321 243.745",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3914 104.864L109.099 88.9235",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5747 112.725L70.8849 116.764C70.8849 116.764 69.3564 117.638 68.2645 115.782C67.1727 113.926 69.5747 112.725 69.5747 112.725Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9917 225.347L42.9033 233.481L46.1788 239.154L60.2672 231.02L56.9917 225.347Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M104.951 123.535C103.422 120.587 101.566 117.857 99.7102 115.018C91.849 122.88 78.4194 132.706 69.0297 123.207C65.4266 119.604 65.9726 114.363 68.1562 110.214C64.444 106.611 60.7318 102.899 57.2379 99.1869C56.2553 100.497 55.2726 102.026 54.5083 103.554C49.5951 112.835 49.9226 124.954 57.2379 132.925C64.5532 141.004 75.799 143.624 86.2806 141.004C94.5785 138.93 101.457 134.344 107.571 128.666C106.698 126.919 105.824 125.173 104.951 123.535Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M99.71 115.018C107.134 107.812 111.174 104.755 107.899 110.542C105.933 114.145 108.335 112.725 112.594 109.341C116.852 105.956 113.685 112.18 111.938 114.472C111.938 114.472 116.524 109.778 117.725 110.979C118.926 112.289 114.231 117.093 114.231 117.093C114.231 117.093 118.926 112.507 119.472 114.472C119.909 116.11 110.301 125.609 107.462 128.666",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M99.71 115.018C107.134 107.812 111.174 104.755 107.899 110.542C105.933 114.145 108.335 112.725 112.594 109.341C116.852 105.956 113.685 112.18 111.938 114.472C111.938 114.472 116.524 109.778 117.725 110.979C118.926 112.289 114.231 117.093 114.231 117.093C114.231 117.093 118.926 112.507 119.472 114.472C119.909 116.11 110.301 125.609 107.462 128.666",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3551 67.9623L89.4469 66.8705C89.4469 66.8705 88.2459 64.796 84.9704 62.7215C81.5857 60.6471 75.2531 63.1583 76.5633 68.5082C77.1092 70.9103 78.201 72.4388 79.5112 73.3123L77.4367 84.449C76.2357 84.9949 75.1439 85.5408 73.9429 86.0867C74.1612 86.4143 74.3796 86.7418 74.7072 87.0694C76.0174 88.4888 77.7643 89.3622 80.1663 89.3622C83.4418 89.3622 85.6255 87.7245 86.7173 85.5408C87.3724 84.2306 87.7 82.7021 87.5908 81.1735C86.6081 81.3919 85.6255 81.6102 84.752 81.9378L86.1714 73.3123C89.4469 71.6746 88.3551 67.9623 88.3551 67.9623Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3158 62.3931C85.1893 64.686 82.023 66.8696 80.3852 67.7431C79.1842 68.3982 79.9485 70.0359 81.1495 70.0359C82.1322 70.0359 80.7128 72.5471 80.1669 72.8747C79.9485 72.9839 79.7301 73.0931 79.5118 73.2023C78.0924 72.438 77.1097 70.9094 76.4547 68.289C75.1445 63.2666 82.8965 54.3136 84.3158 62.3931Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6594 65.8866L82.0217 64.2489C81.585 63.8122 80.7115 63.8122 80.2748 64.2489C79.838 64.6856 79.838 65.4499 80.3839 65.9958C80.9299 66.5417 81.4758 67.0877 82.0217 67.6336C82.4584 68.0703 83.3319 68.0703 83.7686 67.6336C84.2053 67.0877 84.2054 66.3234 83.6594 65.8866Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclined);
export default __webpack_public_path__ + "static/media/declined.8c43b82d3830c250e083ecaa4580712c.svg";
export { ForwardRef as ReactComponent };